// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__lhNAR","block":"modal_block__74I5Y"};